import React, { useState, useEffect } from 'react'
import moment from 'moment-timezone'
import { Link, Redirect, useParams } from 'react-router-dom'
import CountdownTimer from './WalkTest/CountdownTimer'
import { apiRequest } from '../reducers/data'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'

import Resource from '../Resource'

const enable = new Audio(require('../sounds/enable-sound.mp3'))
const disable = new Audio(require('../sounds/disable-sound.mp3'))
const getTimezone = function (user) {
  if (user.profile && user.profile.timezone) {
    return this.profile.timezone
  }
  return 'America/Chicago'
}
const WalkTestContainer = (props) => {
  const { me } = props
  const { id } = useParams()

  const [step, setStep] = useState(0)
  const [nextMinute, setNextMinute] = useState() //date rounded to the next future minute
  const [afterSix, setAfterSix] = useState() //six minutes after that minute
  const SIX_MINUTES = 6 * 60 * 1000

  function roundToNearestMinute(date = new Date()) {
    const minutes = 1
    const ms = 1000 * 60 * minutes

    return new Date(Math.ceil(date.getTime() / ms) * ms + ms) //ensure user has one full minute plus additional seconds
  }

  const onStartWalkTest = async (walkTest, onUpdate) => {
    await window.store.dispatch(
      apiRequest(['me', 'walktest/attempt'], 'PUT', { walkTest: walkTest })
    )

    // begin on the next even minute plus one minute to ensure we give 60-119 seconds to get ready.
    const rounded = roundToNearestMinute()
    setAfterSix(rounded.getTime() + SIX_MINUTES)
    setNextMinute(rounded)
    setStep(1)
  }
  const onBeginWalking = async (walkTest, onUpdate) => {
    enable.play()
    setStep(2)
    console.log('Record Next Minute', nextMinute.toISOString())
    await window.store.dispatch(
      apiRequest(['me', 'walktest/finish'], 'PUT', {
        walkTest: walkTest,
        startDate: nextMinute.toISOString(),
      })
    )
  }

  const onFinishedTest = async (walkTest, onUpdate) => {
    console.log('onFinished')
    setStep(3)

    disable.play()
  }

  const ActiveStep = (props) => {
    const { walkTest, onUpdate } = props

    console.log(props)
    if (walkTest.length == 0) {
      return <p>No test found</p>
    }

    if (walkTest.attempts >= 3) {
      return <p>You're not allowed to attempt this walk test again.</p>
    }
    switch (step) {
      case 0:
        return (
          <div className="step step1">
            <span>Get Ready to Start the Test</span>
            <ul>
              <li>
                Go to an area with an even surface where you can safely walk non-stop for 6-minutes
                – wear proper shoes
              </li>
              <li>Have your caregiver next to you to help you through the test</li>
              <li>Be sure you are wearing your Fitbit or Apple Watch</li>
              <li>After you click start your test will countdown and begin on the next minute</li>
            </ul>
            <button className="black block" onClick={() => onStartWalkTest(walkTest, onUpdate)}>
              Start
            </button>
          </div>
        )
        break
      case 1:
        return (
          <div className="step step2">
            <CountdownTimer
              targetDate={nextMinute}
              onEnd={() => onBeginWalking(walkTest, onUpdate)}
            />
            <span>GET READY</span>
            <ul>
              <li>Begin walking when the time runs out</li>
              <li>
                You should walk as fast as you safely can but pace your speed to be able to walk for
                the full 6-minutes
              </li>
              <li>
                <strong>If you feel dizzy or at risk of falling, PLEASE STOP</strong>
              </li>
            </ul>
          </div>
        )
        break
      case 2:
        return (
          <div className="step step3">
            <CountdownTimer
              targetDate={afterSix}
              onEnd={() => onFinishedTest(walkTest, onUpdate)}
            />
            <span>Begin Walking</span>
            <p>Continue walking for the full six minutes.</p>
          </div>
        )
        break
      case 3:
        return (
          <div className="step step4">
            <div className="show-counter">
              <CircularProgressbar
                value={100}
                text={`STOP WALKING`}
                styles={buildStyles({
                  // Colors
                  pathColor: `red`,
                  textColor: 'red',
                  textSize: '10px',
                })}
              />
            </div>
            <span>You have completed your test</span>
            <p>
              Click <strong>Exit</strong> at the right upper corner
            </p>
          </div>
        )

      default:
        break
    }
  }
  return (
    <div className="screen walk_test">
      <div className="navigation-bar">
        <div className="title">6-minute walk test</div>
        <Link to="/mobile/news" className="button-item right">
          Exit
        </Link>
      </div>
      {id ? (
        <Resource collection path={['walkTests', id / 1]} placeholder={[]}>
          {(walkTest, { onCreateItem, onUpdateItem, onDeleteItem, dispatch }) => (
            <ActiveStep walkTest={walkTest} onUpdate={onUpdateItem} />
          )}
        </Resource>
      ) : (
        <p>You've not been assigned a walk test</p>
      )}
    </div>
  )
}
export default WalkTestContainer
